import startCase from 'lodash/startCase'
export default function format (entity, item, type = 'table') {
    switch (entity) {
        case 'drug':
            switch (type) {
                case 'subtitle':
                case 'table':
                    return item?.packaging !== 'Labels' ? `${item?.packaging}, ${item?.dose}${item?.measure_unit}` : `${item?.packaging} - ${item?.labels?.join(',')}`
                case 'audit_trail':
                    if (!item) return ''
                    return item?.name + ' ' + (item?.packaging !== 'Labels' ? `${item?.packaging}, ${item?.dose}${item?.measure_unit}` : `${item?.packaging} - ${item?.labels?.join(',')}`)
            }
            break
        case 'account':
            return item?.name && `${item?.name} ${item?.surname ?? ''}`
        // special case to transform field name into label (mainly used for audit trail foreigns)
        case 'field_name':
            if (item === 'n_pieces') {
                return 'Quantity'
            }
            return startCase(item.replace('_', ' ').replace(/ id$/, ''))
        case 'field_value':
            return item
        default:
            return item?.name ?? item
    }
}